import { createContext, useContext } from 'react';
const CsrfTokenContext = createContext(null);

export const CsrfTokenProvider = ({ csrfToken, children }) => {
    return (
        <CsrfTokenContext.Provider value={csrfToken}>
            {children}
        </CsrfTokenContext.Provider>
    );
};

export const useCsrfToken = () => useContext(CsrfTokenContext);
